import Language from './Language';

type Category = 'PA' | 'AUDIT' | 'CERTIFICATE' | 'OTHER';

interface Document {
    id: number;
    documentName: string;
    mimeType: string;
    note: string | null;
    category: Category;
    creationDate: string;
    modificationDate: string;
    companyId: number;
    userId: number;
    extension: string;
    userName: string;
    year: number | null;
    language: Language | null;
}

const EmptyDocument: Document = {
    id: 0,
    documentName: '',
    mimeType: '',
    note: null,
    category: 'OTHER',
    creationDate: '',
    modificationDate: '',
    companyId: 0,
    userId: 0,
    extension: '',
    userName: '',
    year: null,
    language: null
};

export { EmptyDocument };


export default Document;
